<template>
  <div class="container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item class="black">{{
        t("customermanagement")
      }}</a-breadcrumb-item>
      <a-breadcrumb-item class="black">
        <router-link :to="`${routerName.customerList}`">
          {{ t("customerlist") }}</router-link
        >
      </a-breadcrumb-item>
      <a-breadcrumb-item class="currentrouter">{{
        t("usermanage")
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="search-input-group">
      <a-input
        style="width: 15%"
        v-model:value="searchKeyword"
        :placeholder="t('supportphonenamesearch')"
      />
      <a-button class="searchBtn" @click="search" :disabled="disabledButton">{{
        t("search")
      }}</a-button>
      <a-button
        class="searchBtn addBtn"
        @click="showModal(1)"
        :disabled="disabledButton"
        style="right: 0"
        >{{ t("batchdelete") }}</a-button
      >
      <a-button
        class="searchBtn addBtn"
        @click="addUserF"
        :disabled="disabledButton"
        >{{ t("add") }}</a-button
      >
    </div>
    <a-table
      :data-source="dataList"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: maxHeight }"
      :row-selection="rowSelection"
    >
      <template #bodyCell="{ record, column }">
        <template v-if="column.dataIndex === 'phone'">
          <div
            style="align-items: center"
            v-if="record.phone || record.username"
          >
            <span>{{ record.phone }}</span>
          </div>
          <div style="align-items: center" v-else>
            <a-select
              v-model:value="addNewUser"
              :placeholder="t('pleaseselct')"
              style="width: 90%; margin: -5px 0"
              showSearch
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in bindUserList"
                :key="item.id"
                v-model:value="item.id"
                :label="item.phone"
                :disabled="item.disable"
              >
                <span style="float: left">{{
                  item.phone
                }}</span></a-select-option
              >
            </a-select>
          </div>
        </template>
        <template v-if="column.dataIndex === 'username'">
          <div style="align-items: center" v-if="record.username">
            <span>{{ record.username }}</span>
          </div>
          <div style="align-items: center" v-else>
            <a-select
              v-model:value="addNewUser"
              :placeholder="t('pleaseselct')"
              size="large"
              style="width: 90%; margin: -5px 0"
              showSearch
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in bindUserList"
                :key="item.id"
                :label="item.username"
                v-model:value="item.id"
              >
                <span style="float: left">{{ item.username }}</span>
              </a-select-option>
            </a-select>
          </div>
        </template>
        <template v-if="column.dataIndex === 'agent_info'">
          <div v-if="record.agent_info">
            {{ record.agent_info.agent_name }}
          </div></template
        >
        <template v-if="column.dataIndex === 'userrole'">
          {{ record.roles ? record.roles.role_name : "" }}</template
        >
        <template v-if="column.dataIndex === 'type'">
          <div v-if="record.type == '2'">{{ t("domesticusers") }}</div>
          <div v-if="record.type == '1'">
            {{ t("internationalusers") }}
          </div></template
        >
        <template v-if="column.dataIndex === 'car_model'">
          <div class="operate">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" @click="checkItem(record)">
                <img
                  v-if="record.id !== checkedId"
                  src="../assets/images/notclicked.png"
                  alt=""
                />
                <img v-else src="../assets/images/clicked.png" alt="" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item
                    v-if="record.id"
                    key="0"
                    @click="showModal(2, record.id)"
                    :disabled="disabledButton"
                  >
                    {{ t("delete") }}</a-menu-item
                  ><a-menu-divider />
                  <a-menu-item
                    key="1"
                    v-if="record.id"
                    @click="resetPasswd(record.id)"
                    :disabled="disabledButton"
                    >{{ t("resetpassword") }}</a-menu-item
                  >
                  <a-menu-item
                    v-if="!record.id"
                    key="2"
                    @click="SaveBindUser"
                    >{{ t("save") }}</a-menu-item
                  >
                  <a-menu-divider />
                  <a-menu-item
                    v-if="!record.id"
                    key="3"
                    @click="CancelAddVehicleF"
                    >{{ t("cancellation") }}</a-menu-item
                  >
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
      </template>
    </a-table>
    <a-pagination
      class="pagination"
      show-size-changer
      show-quick-jumper
      :show-total="(totalNum) => `${t('intotal')} ${totalNum} ${t('article')}`"
      v-model:current="pagination.page"
      v-model:pageSize="pagination.size"
      :total="pagination.totalNum"
      size="small"
      @change="getListData"
    />
    <a-modal
      v-model:open="open"
      :title="t('tips')"
      @ok="handleOk"
      :closable="false"
    >
      <template #footer>
        <a-button key="back" @click="open = false">{{
          t("cancellation")
        }}</a-button>
        <a-button key="submit" type="primary" @click="handleOk">{{
          t("determine")
        }}</a-button>
      </template>
      <div
        style="
          height: 100px;
          line-height: 50px;
          border-top: 1px solid #eaeaea;
          border-bottom: 1px solid #eaeaea;
        "
      >
        <span
          role="img"
          aria-label="exclamation-circle"
          class="anticon anticon-exclamation-circle"
          style="color: #feb300"
          ><svg
            focusable="false"
            class=""
            data-icon="exclamation-circle"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
            viewBox="64 64 896 896"
          >
            <path
              d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
            ></path></svg
        ></span>
        {{ t("areyousure")
        }}{{ buttonType === 1 ? t("batchdelete") : t("delete")
        }}{{ t("selecteddata") }}？
      </div>
    </a-modal>
  </div>
</template>
<script>
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import { message } from "ant-design-vue";
import { onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import routerName from "@/router/routerName";
import { useI18n } from "vue-i18n";
export default {
  name: "OrgUserManagement",
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const searchKeyword = ref("");
    const route = useRoute();
    const user_id = route.query.id;
    const disabledButton = ref(false);
    const pagination = ref({
      totalNum: 0,
      page: 1,
      size: 10,
    });
    const dataList = ref([]);
    const getListData = () => {
      const param = {
        org_id: user_id,
        page: pagination.value.page,
        size: pagination.value.size,
        keyword: searchKeyword.value,
      };
      Api.getOrgUserLists(param).then((val) => {
        if (val.err_no == ResultCodeType.success_200) {
          if (val.result.length > 0) {
            dataList.value = val.result.map((item) => {
              return {
                ...item,
                key: item.id,
              };
            });
            pagination.value.totalNum = Number(val.total_num);
          } else {
            dataList.value = [];
          }
        } else {
          message.error(val.err_msg);
        }
      });
    };
    const search = () => {
      pagination.value.page = 1;
      getListData();
    };
    const bindUserList = ref([]);
    const getBindUser = () => {
      const params = {
        org_id: user_id,
      };
      Api.getBindUserList(params).then((result) => {
        bindUserList.value = result.result;
      });
    };
    getBindUser();

    // 新建工作站form
    const addVehicleForm = ref({
      org_id: user_id,
      user_id: "",
    });
    const isNewList = ref(false);

    // 新增按钮点击
    const addUserF = () => {
      isNewList.value = false;
      disabledButton.value = true;
      dataList.value.unshift(addVehicleForm);
    };

    // 保存按钮
    const addNewUser = ref("");
    const SaveBindUser = () => {
      if (addNewUser.value === "") {
        message.error(t("selectphonenumber"));
        return;
      }
      const params = {
        org_id: user_id,
        user_id: addNewUser.value,
      };
      Api.getBindUser(params)
        .then((val) => {
          if (val.err_no == ResultCodeType.success_200) {
            message.success(t("savetime"));
            disabledButton.value = false;
            addNewUser.value = "";
            getListData();
            getBindUser();
          } else {
            message.error("保存失败，请重试！");
          }
        })
        .catch(() => {
          message.error("保存失败，请重试！");
        });
    };

    // 取消按钮
    const CancelAddVehicleF = () => {
      dataList.value.shift();
      disabledButton.value = false;
      addNewUser.value = "";
    };

    // 批量删除
    const delListUserF = () => {
      const delList = JSON.parse(JSON.stringify(checkedList.value));
      const delUserList = [];
      for (let i = 0; i < delList.length; i++) {
        delUserList.push(delList[i]);
      }
      const params = {
        org_id: user_id,
        user_ids: delUserList.join(","),
      };
      if (delUserList.length) {
        Api.delBindUser(params)
          .then((val) => {
            if (val.err_no == ResultCodeType.success_200) {
              message.success(t("successfullydeleted"));
              getBindUser();
              getListData();
            } else {
              message.error(val.err_msg);
            }
          })
          .finally(() => {
            open.value = false;
          });
      } else {
        message.error("未选择用户");
      }
    };

    // 删除
    const delUserF = (id) => {
      const params = {
        org_id: user_id,
        user_ids: id,
      };
      Api.delBindUser(params)
        .then((val) => {
          if (val.err_no == ResultCodeType.success_200) {
            message.success(t("successfullydeleted"));
            getBindUser();
            getListData();
          } else {
            message.error(val.err_msg);
          }
        })
        .finally(() => {
          open.value = false;
        });
    };
    const resetPasswd = (id) => {
      const params = {
        id: id,
      };
      Api.resetPasswd(params).then((val) => {
        if (val.err_no == ResultCodeType.success_200) {
          message.success(t("passwordresetto") + "：idriverplus");
          getBindUser();
          getListData();
        } else {
          message.error(val.err_msg);
        }
      });
    };
    const checkedList = ref([]);
    const rowSelection = {
      onChange: (selectedRowKeys) => {
        checkedList.value = selectedRowKeys;
      },
    };
    const filterOption = (input, option) => {
      if (option.label) {
        return option.label.indexOf(input.toLowerCase()) >= 0;
      } else {
        return false;
      }
    };
    const columns = [
      {
        title: t("tel"),
        dataIndex: "phone",
        key: "phone",
        align: "center",
      },
      {
        title: t("username"),
        dataIndex: "username",
        key: "username",
        align: "center",
      },
      {
        title: t("agent"),
        dataIndex: "agent_info",
        key: "agent_info",
        align: "center",
      },
      {
        title: t("userrole"),
        dataIndex: "roles",
        key: "roles",
        align: "center",
      },
      {
        title: t("customertype"),
        dataIndex: "type",
        key: "type",
        align: "center",
      },
      {
        title: t("usercomments"),
        dataIndex: "remark",
        key: "remark",
        align: "center",
      },
      {
        title: t("operate"),
        dataIndex: "car_model",
        key: "car_model",
        align: "center",
        width: 100,
      },
    ];
    const checkedId = ref("");
    const checkItem = (value) => {
      checkedId.value = value.id;
    };
    const open = ref(false);
    const beDeletedId = ref("");
    const buttonType = ref(1);
    const showModal = (type, id) => {
      if (type === 1 && checkedList.value.length === 0) {
        message.error(t("nouserselected"));
        return;
      }
      buttonType.value = type;
      beDeletedId.value = id;
      open.value = true;
    };

    const handleOk = () => {
      if (buttonType.value === 1) {
        delListUserF();
      } else {
        delUserF(beDeletedId.value);
      }
    };
    onMounted(() => {
      getListData();
      getBindUser();
    });
    return {
      buttonType,
      showModal,
      open,
      handleOk,
      checkedId,
      checkItem,
      rowSelection,
      columns,
      getListData,
      addNewUser,
      bindUserList,
      filterOption,
      searchKeyword,
      pagination,
      dataList,
      addUserF,
      delListUserF,
      CancelAddVehicleF,
      SaveBindUser,
      delUserF,
      disabledButton,
      resetPasswd,
      search,
      maxHeight,
      routerName,
      t,
    };
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.disabled {
  color: #ccc !important;
  pointer-events: none;
}
</style>
